import { gql } from '@apollo/client';

export const fetchInvoicesForTransactionAccount = gql`
  query fetchInvoicesForTransactionAccount($id: ID!, $searchOptions: ConnectionSearchOptions) {
    transactionAccount(id: $id) {
      id
      invoices(searchOptions: $searchOptions) {
        totalCount
        nodes {
          id
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pdfLink
          refunds {
            id
            type
            createdDate
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          status
          dunningStatus {
            errorCode
          }
          shipTo {
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          purchaseOrderNumber
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
